"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useSelectionIndicatorStyles = ({ disabled, min, max, count, fullWidth, splitByShareV2UI }) => {
    const theme = (0, material_1.useTheme)();
    const container = {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        padding: splitByShareV2UI ? '3.7px' : '0',
        gap: '8px',
        width: '100%',
        height: splitByShareV2UI ? '43px' : '24px',
        backgroundColor: splitByShareV2UI ? theme.palette.primary.main : 'inherit',
        borderRadius: splitByShareV2UI ? '20px' : 'none',
    };
    const splitByItemUIButton = {
        disabledBackground: disabled ? theme.qlub.palette.dim.main : theme.palette.background.default,
        hoverBackground: disabled ? theme.qlub.palette.dim.main : theme.qlub.palette.dim.main,
    };
    const defaultButton = {
        disabledColor: disabled ? 'transparent' : theme.qlub.palette.dim.main,
        hoverColor: disabled ? 'transparent' : theme.palette.secondary.light,
    };
    const button = {
        background: disabled ? 'transparent' : theme.palette.secondary.light,
        width: splitByShareV2UI ? '35px' : '28px',
        height: splitByShareV2UI ? '35px' : '28px',
        borderRadius: '100px',
        '&.Mui-disabled': {
            background: splitByShareV2UI ? splitByItemUIButton === null || splitByItemUIButton === void 0 ? void 0 : splitByItemUIButton.disabledBackground : defaultButton === null || defaultButton === void 0 ? void 0 : defaultButton.disabledColor,
        },
        '&:hover': {
            background: splitByShareV2UI ? splitByItemUIButton === null || splitByItemUIButton === void 0 ? void 0 : splitByItemUIButton.hoverBackground : defaultButton === null || defaultButton === void 0 ? void 0 : defaultButton.hoverColor,
        },
    };
    const minButton = {
        background: count === 0 || (min && count <= min) || disabled
            ? `${theme.qlub.palette.dim.main} !important`
            : splitByShareV2UI
                ? theme.palette.background.default
                : theme.palette.secondary.main,
    };
    const maxButton = {
        background: (max && count >= max) || disabled
            ? `${theme.qlub.palette.dim.main} !important`
            : splitByShareV2UI
                ? theme.palette.background.default
                : theme.palette.secondary.main,
    };
    const icon = {
        fontSize: '24px',
    };
    const plusIcon = {
        color: (max && count >= max) || disabled
            ? theme.qlub.palette.onSurfaceColors.disabled
            : `${theme.palette.primary.main} !important`,
    };
    const minusIcon = {
        color: count === 0 || (min && count <= min) || disabled
            ? theme.qlub.palette.onSurfaceColors.disabled
            : `${theme.palette.primary.main} !important`,
    };
    const checkIcon = {
        color: `${theme.palette.primary.main} !important`,
    };
    const text = {
        width: '18px',
        height: '20px',
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '146.02%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        letterSpacing: '0.0025em',
        color: splitByShareV2UI ? theme.palette.background.default : theme.qlub.palette.onSurfaceColors.mediumEmphasis,
    };
    const indicator = {
        width: fullWidth ? '100%' : '82px',
        minWidth: splitByShareV2UI ? '100px' : 'none',
        height: '24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    };
    const paidIcon = {
        fontSize: '22px',
    };
    const paidUserIcon = {
        padding: '7px',
        color: 'white',
        borderRadius: '100%',
        width: '2rem',
        height: '2rem',
        backgroundColor: theme.palette.grey[500],
        fontWeight: '100',
        cursor: 'default',
    };
    const paidCheckIcon = {
        padding: '7px',
        color: 'white',
        borderRadius: '100%',
        width: '2rem',
        height: '2rem',
        backgroundColor: theme.palette.primary.main,
        fontWeight: '100',
        cursor: 'pointer',
    };
    const paidPlusIcon = {
        padding: '5px',
        color: theme.palette.grey[700],
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: '100%',
        width: '2rem',
        height: '2rem',
        backgroundColor: 'white',
        fontWeight: '100',
        cursor: 'pointer',
    };
    return {
        container,
        button,
        icon,
        plusIcon,
        minusIcon,
        text,
        indicator,
        minButton,
        checkIcon,
        maxButton,
        paidIcon,
        paidCheckIcon,
        paidPlusIcon,
        paidUserIcon,
    };
};
exports.default = useSelectionIndicatorStyles;
